package com.far.suller.pages

import androidx.compose.runtime.*
import com.far.suller.components.backToTopButton
import com.far.suller.components.header
import com.far.suller.components.overflowMenu
import com.far.suller.models.Theme
import com.far.suller.sections.*
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.core.Page

@Page
@Composable
fun homePage() {
    var menuOpened by remember { mutableStateOf(false) }

    Box(modifier = Modifier.fillMaxSize().backgroundColor(Theme.Background.rgb)) {
        // Page content
        Column(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.Top,
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            mainSection(onMenuClicked = { menuOpened = true })
            skillsSectionV2()
            experienceSectionV2()
            portfolioSectionV2()
            serviceSectionV2()
            testimonialSection()
            aboutMeSection()
            contactSection()
            footerSection()
        }

        // Fixed header overlaid on top of all content
        header(onMenuClicked = { menuOpened = true })

        backToTopButton()

        if (menuOpened) {
            overflowMenu(onMenuClosed = { menuOpened = false })
        }
    }
}
